import clsx from "clsx";
import React from "react";
import Avatar, { genConfig } from "react-nice-avatar";

interface Props {
  className?: string;
  seed: string;
  shape?: "square" | "circle" | "rounded";
}
const NiceAvatar: React.FC<Props> = ({ className, seed, shape = "square" }) => {
  return (
    <Avatar
      className={clsx("w-full h-full object-cover", className)}
      {...genConfig(seed)}
      shape={shape}
    />
  );
};

export default NiceAvatar;
